import styled from "styled-components";

export const LanguageBoxWrapper = styled.div.attrs((props) => ({}))`
	transition: 0.3s ease;
	z-index: ${({ open }) => (open ? "1" : "0")};
	flex-wrap: wrap;
	display: flex;
	height: 7rem;
	width: 100%;
	max-width: ${({ width }) => (width ? width : "")};
	align-items: center;
	transition-delay: 0.2s;
	button {
		transition-delay: 0.2s;
		transition: 0.2s ease;
	}

	justify-content: center;
	background-color: ${({ bgColor }) => (bgColor ? bgColor : "transparent")};
`;
